import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from '@/components/ui/button';
import { DailyQuest } from '@/models/DailyQuest';
import { Badge } from '@/components/ui/badge';
import { Sparkles } from 'lucide-react';

interface DailyQuestCardProps {
  quest: DailyQuest;
  onStartQuest: (quest: DailyQuest) => void;
}

export const DailyQuestCard: React.FC<DailyQuestCardProps> = ({ 
  quest, 
  onStartQuest 
}) => {
  const isAvailable = quest.isAvailable;
  const wasCompletedToday = !!quest.lastCompletedAt;

  return (
    <Card className={`w-full max-w-sm transition-all duration-300 ${!isAvailable ? 'opacity-60' : 'hover:shadow-md'}`}>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center justify-between">
          {quest.name}
          {wasCompletedToday && (
            <Badge variant="secondary" className="ml-2">
              Completed Today
            </Badge>
          )}
        </CardTitle>
        <CardDescription>{quest.description}</CardDescription>
      </CardHeader>
      
      <CardContent>
        <div className="flex items-center text-sm text-muted-foreground">
          <Sparkles className="h-4 w-4 mr-1" />
          <span className="font-medium text-primary">{quest.bonusXP} XP</span>
          <span className="ml-1">bonus on completion</span>
        </div>
      </CardContent>
      
      <CardFooter>
        <Button 
          onClick={() => onStartQuest(quest)} 
          disabled={!isAvailable || wasCompletedToday}
          className="w-full"
          variant={wasCompletedToday ? "outline" : "default"}
        >
          {wasCompletedToday ? 'Completed' : isAvailable ? 'Start Quest' : 'Not Available'}
        </Button>
      </CardFooter>
    </Card>
  );
};
